import { handleHttpResponse } from "../../utils/http_response_utils";

export const getDeleteNatgwScheduleState = async () => {
  /** Get delete natgw schedule state */
  const accessToken = localStorage.getItem("access-token");
  const response = await fetch("/api/event-bridge/get-delete-natgw-schedule-state", {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${accessToken}`,
    },
  });
  return await handleHttpResponse(response);
};

export const disableDeleteNatgwSchedule = async () => {
  /** Disable delete natgw schedule */
  const accessToken = localStorage.getItem("access-token");
  const response = await fetch("/api/event-bridge/disable-delete-natgw-schedule", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${accessToken}`,
    },
  });
  return await handleHttpResponse(response);
};

export const enableDeleteNatgwSchedule = async () => {
  /** Enable delete natgw schedule */
  const accessToken = localStorage.getItem("access-token");
  const response = await fetch("/api/event-bridge/enable-delete-natgw-schedule", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${accessToken}`,
    },
  });
  return await handleHttpResponse(response);
};
